/**
 * Опция приоритета (справочник).
 * Класс, а не тип, из-за toString: VSelectV2 печатает опцию через option?.toString(),
 * и голый объект отрисовался бы как [object Object].
 */
class PriorityOption {
    id:    string;
    level: number | null = null;
    name:  string | null = null;

    static fromServer(data: any, priorityOption = new PriorityOption()): PriorityOption {
        priorityOption.id    = data.id;
        priorityOption.level = data.level;
        priorityOption.name  = data.name;

        return priorityOption;
    }

    toString(): string {
        if (this.name === null) {
            return '';
        }
        else {
            return this.name;
        }
    }
}

export default PriorityOption;